import { loginRequest, msalConfigB2E } from "Helpers/AuthConfig";
import {
  AuthenticationResult,
  EventType,
  PublicClientApplication,
  SilentRequest,
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import React, { useCallback, useEffect, useMemo } from "react";

export let msalTemp: PublicClientApplication

interface AuthProviderProps {
  children: React.ReactNode;
}
interface IdTokenClaims {
  roles?: string[];
  exp?: number;
  [key: string]: unknown;
}
export function AuthProvider({
  children,
}: Readonly<AuthProviderProps>): JSX.Element {
  const msalInstance = useMemo(
    () => new PublicClientApplication(msalConfigB2E),
    []
  );
  msalTemp = msalInstance; 

  const setActiveAccount = useCallback(
    (account: AuthenticationResult["account"]): void => {
      msalInstance.setActiveAccount(account);
    },
    [msalInstance]
  );

  useEffect(() => {
    if (
      msalInstance.getActiveAccount() &&
      msalInstance.getAllAccounts().length > 0
    ) {
      setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    const callbackId = msalInstance.addEventCallback((event) => {
      const authenticationResult = event.payload as AuthenticationResult;
      const account = authenticationResult?.account;
      if (event.eventType === EventType.LOGIN_SUCCESS && account) {
        setActiveAccount(account);
        const idTokenClaims =
          authenticationResult.idTokenClaims as IdTokenClaims;
      }
    });

    return () => {
      if (callbackId) {
        msalInstance.removeEventCallback(callbackId);
      }
    };
  }, [msalInstance, setActiveAccount]);

  useEffect(() => {
    const interval = setInterval(async () => {
      const activeAccount = msalInstance.getActiveAccount();
      if (!activeAccount) return;

      const silentRequest: SilentRequest = {
        account: activeAccount,
        scopes: loginRequest.scopes
      };

      try {
        const tokenResponse = await msalInstance.acquireTokenSilent(silentRequest);
        console.log("Token refreshed successfully:", tokenResponse.accessToken);
      } catch (error) {
        console.error("Silent token refresh failed:", error);
        msalInstance.logoutRedirect();
      }
    }, 5 * 60 * 1000); // Refresh token every 5 minutes

    return () => clearInterval(interval);
  }, [msalInstance]);
  
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}
